/* eslint-disable quotes */
import { snakelize, camelize } from "../../../helpers/object";

export default ($axios: any) => ({
  // 카드 조회
  async index(data?: any) {
    return camelize(await $axios.get(`/card`, snakelize({ params: data })));
  },

  // 카드 등록
  async store(data?: any) {
    return camelize(await $axios.post(`/card`, snakelize(data)));
  },

  // 카드 제거
  async delete(data?: any) {
    return camelize(
      await $axios.delete(`/card/${data.id}`, snakelize({ params: data }))
    );
  },

  // 수정
  async update(data: any) {
    return camelize(await $axios.patch(`/card/${data.id}`, snakelize(data)));
  },
});
